import services from 'services'

export default {
  get(uuid, isEmbedded = false) {
    return services.fetch(`/v1/job-opening/${uuid}?isEmbedded=${isEmbedded}`)
  },

  createCandidate(uuid, data, isEmbedded) {
    return services.fetch(
      `/v1/job-opening/${uuid}/candidate?isEmbedded=${isEmbedded}`,
      {
        method: 'POST',
        body: data,
      }
    )
  },
}
